import React, { useEffect, useState } from "react"

import { Col, DatePicker, Divider, Space, Table } from "antd"
import { PrinterFilled } from "@ant-design/icons"
import Typography from "antd/es/typography/Typography"
import { collection, doc, onSnapshot, query, where } from "firebase/firestore"
import { db } from "../../../firebase/config"
import moment from "moment"
import { cutterPrintingCols } from "./CutterTableColumns"
import CutterSequence from "./CutterSequence"
import { calculateProjectedMeters } from "../../Orders/Helpers/CalculateProjectedMeters"

const { Title } = Typography

export default function CutterTable({
  selectedRowKeysArsoma,
  setSelectedRowKeysArsoma,
  tableLoading,
}) {
  //loading data wich are meant to be for arsoma

  //arsoma printer data
  const [arsomaData, setArsomaData] = useState([])

  //array that manages order and gets updates
  const [arsomaSequence, setArsomaSequence] = useState(arsomaData.map((item) => item.id))
  //loading for while data is sorting
  const [isSorting, setIsSorting] = useState(true)
  const [searchDate, setSearchDate] = useState(moment().unix())

  //gets array of the sequence
  useEffect(() => {
    const sequenceDocRef = doc(db, "sequence", "bpIeedOJcahszryHT9lr")
    const unsubscribe = onSnapshot(sequenceDocRef, (doc) => {
      if (doc.exists()) {
        const sequenceData = doc.data()
        setArsomaSequence(sequenceData.cutterSequence)
        console.log("sequence")
      }
    })

    return () => unsubscribe()
  }, [])

  //fetches the documents, then uses the sequence array to sort in correct order
  useEffect(() => {
    const ref = collection(db, "orders")
    let q = query(
      ref,
      where("orderStatus", "==", 4.5),
      where("selectedProduct.machine", "==", "Cutter")
    )

    const unsubscribe = onSnapshot(q, async (snapshot) => {
      let results = []
      snapshot.docs.forEach((doc) => {
        const data = doc.data()
        results.push({ ...data, key: doc.id, id: doc.id })
      })

      // Fetch knife data and calculate projected meters in batch
      const orderWithMeters = await Promise.all(
        results.map((order) => calculateProjectedMeters(order))
      )

      // sort the results based on the arsomaSequence state
      const sortedResults = orderWithMeters.sort((a, b) => {
        return arsomaSequence.indexOf(a.id) - arsomaSequence.indexOf(b.id)
      })
      setArsomaData(sortedResults)
      setIsSorting(false)
      console.log(sortedResults)
    })

    return () => unsubscribe()
  }, [arsomaSequence, searchDate])

  //select for swaping data between tables
  const onSelectChangeArsoma = (newSelectedRowKeysArsoma) => {
    console.log("selectedRowKeys changed: ", newSelectedRowKeysArsoma)
    setSelectedRowKeysArsoma(newSelectedRowKeysArsoma)
  }

  const rowSelectionArsoma = {
    selectedRowKeysArsoma,
    onChange: onSelectChangeArsoma,
  }

  const onChange = (date, dateString) => {
    const dateM = moment(dateString)
    const unixTimestamp = dateM.unix()
    setSearchDate(unixTimestamp)
    console.log(unixTimestamp)
  }

  return (
    <div>
      {/* ARSOMA TABLE */}
      <Col span={24}>
        <Title level={4}>
          <PrinterFilled style={{ color: "green" }} />
          <Divider type="vertical" />
          Cutter List
        </Title>
        <Col span={24}>
          <Space>
            <CutterSequence
              tableLoading={tableLoading}
              vivaSequence={arsomaSequence}
              setVivaSequence={setArsomaSequence}
              vivaData={arsomaData}
              setVivaData={setArsomaData}
            />
            <DatePicker onChange={onChange} />
          </Space>
        </Col>
        <Table
          style={{ marginTop: "15px" }}
          size="small"
          loading={isSorting || tableLoading}
          columns={cutterPrintingCols}
          dataSource={arsomaData}
          rowSelection={rowSelectionArsoma}
          rowKey={(record) => record.id}
          pagination={{ defaultPageSize: "12", showSizeChanger: true }}
        />
      </Col>
    </div>
  )
}
